export type FilePurpose = 'logo_square' | 'logo_horizontal' | 'card_front' | 'seal';

/* ------------------------------ Peticiones (lo que se ENVÍA) ------------------------------ */

/** Body de POST /files/presign. La API valida con estos datos (no los guarda). */
export interface IPresignRequest {
  idCompany: string;
  purpose: FilePurpose;
  fileName: string;
  mimeType: string;
  sizeBytes: number;
}

/** Body de POST /files/confirm. La API valida con estos datos (no los guarda en FILES). */
export interface IFileConfirmRequest {
  s3Key: string;
  idCompany: string;
  purpose: FilePurpose;
  originalName: string;
  mimeType: string;
  sizeBytes: number;
  width: number | null;
  height: number | null;
}

/* ------------------------------ Respuestas (lo que se RECIBE) ------------------------------ */

/** Respuesta de POST /files/presign. */
export interface IPresign {
  presignedUrl: string;
  s3Key: string;
  expiresIn: number;
}

/**
 * Archivo ya guardado (tabla FILES). La API ya no devuelve idCompany, originalName, mimeType,
 * sizeBytes, width, height ni status: si se necesitan, se toman del archivo local antes de subir.
 */
export interface IFileMedia {
  idFile: string;
  urlFile: string;
  path?: string;
  fileType?: string;
  createdAt?: string;
}

/** Reglas por propósito (contrato POST /files/presign y /files/confirm). */
export const FILE_RULES: Record<FilePurpose, { mimes: string[]; maxBytes: number; exact?: [number, number]; min?: [number, number] }> = {
  logo_square: { mimes: ['image/png'], maxBytes: 1024 * 1024, exact: [512, 512] },
  logo_horizontal: { mimes: ['image/png'], maxBytes: 2 * 1024 * 1024, exact: [1200, 400] },
  card_front: { mimes: ['image/png', 'image/jpeg'], maxBytes: 10 * 1024 * 1024, min: [1800, 1030] },
  seal: { mimes: ['image/png', 'image/svg+xml'], maxBytes: 5 * 1024 * 1024 },
};
